import styled from 'styled-components';

import { LightBlueButton } from 'components/primitives/content';

export const Button = styled(LightBlueButton).attrs(() => ({ small: true }))`
  width: 119px;
  font-size: 14px;
  padding: 5px;
`;
